export default {
  pullRefresh: {
    TITLE: 'Enjoy your Global Store shopping journey',
    PULL_REFRESH: 'Pull down to refresh',
    RELEASE_REFRESH: 'Release to refresh',
    LOADING: 'Loading...'
  },
  LOGIN_TOOLTIP: {
    TEXT: 'Synchronize global quality of life',
    BUTTON_TEXT: 'Log in',
    OPEN_APP: 'Open APP'
  }
};
